import React from "react";
import { Link, graphql } from "gatsby";
import Slider from "react-slick";
import ReactPlayer from "react-player";
import useTranslation from "locales";

import Layout from "components/Layout";
import Seo from "components/Seo";

import GardenSlider from "components/GardenSlider";
import NewsTile from "components/NewsTile";
import Newsletter from "components/Newsletter";

import "styles/pages/page-home.scss";

const Home = ({ pageContext, data }) => {
	const lang = pageContext.language?.slug;
	const { t } = useTranslation(lang);
	const seo = pageContext.seo;
	const home = pageContext.data;
	const posts = data.allWpPost.nodes;
	const postsFilteredByLang = posts.filter((el) => {
		return el.language.slug === lang;
	});

	const newsSliderOptions = {
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		autoplay: false,
		speed: 1000,
		draggable: true,
		adaptiveHeight: true,
		infinite: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					adaptiveHeight: true,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					adaptiveHeight: true,
				},
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	const clientsSliderOptions = {
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 1000,
		pauseOnHover: false,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	};

	const realizationsSlider = {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		autoplay: false,
		speed: 1000,
		fade: true,
	};

	const videoSlider = {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		autoplay: false,
		speed: 1000,
		fade: true,
	};

	return (
		<Layout className="bg" lang={lang}>
			<Seo
				title={seo.title ? seo.title : pageContext.title}
				description={seo.metaDesc}
			/>
			<GardenSlider lang={lang} generalSlide />
			<section className="section-project">
				<div className="container">
					<div className="row">
						<div className="col-lg-5">
							<h3 className="section-project__title">
								{home.introtitle}
							</h3>
							<p className="section-project__text">
								{home.introtext}
								<Link
									to={t("/o-firmie/")}
									className="link-line section-project__btn"
								>
									{t("Więcej")}
								</Link>
							</p>
						</div>
						<div className="col-lg-6 offset-lg-1">
							<Slider {...videoSlider}>
								<div>
									<div className="section-project__video">
										<ReactPlayer
											url="https://www.youtube.com/watch?v=mV4Iyoo66X8"
											width="100%"
										/>
									</div>
								</div>
								<div>
									<div className="section-project__video">
										<ReactPlayer
											url="https://www.youtube.com/watch?v=gK0vH8Yf4bs"
											width="100%"
										/>
									</div>
								</div>
								<div>
									<div className="section-project__video">
										<ReactPlayer
											url="https://www.youtube.com/watch?v=gxgJ85WcM4Q"
											width="100%"
										/>
									</div>
								</div>
								<div>
									<div className="section-project__video">
										<ReactPlayer
											url="https://www.youtube.com/watch?v=q-u3BD-7k_A"
											width="100%"
										/>
									</div>
								</div>
							</Slider>
						</div>
					</div>
				</div>
			</section>

			<section className="section-realizations">
				<h2 className="section-realizations__title">
					{home.realizationstitle}
				</h2>
				<div className="section-realizations__slider-container">
					<Slider {...realizationsSlider}>
						{home.homeRealizations?.map((item, index) => {
							return (
								<div key={index}>
									<div className="row">
										<div className="col-md-6 section-realizations__col section-realizations__col--img">
											<img
												src={item.logo?.sourceUrl}
												alt=""
												className="img-fluid section-realizations__logo section-realizations__logo--mobile"
											/>
											<img
												src={item.img?.sourceUrl}
												alt=""
												className="img-fluid"
											/>
										</div>
										<div className="col-xl-3 col-lg-4 col-md-6 offset-xl-1 section-realizations__col section-realizations__wrapper">
											<img
												src={item.logo?.sourceUrl}
												alt=""
												className="img-fluid section-realizations__logo"
											/>
											<div
												className="section-realizations__text"
												dangerouslySetInnerHTML={{
													__html: item.text,
												}}
											/>
											<Link
												to={item.link?.uri}
												className="link-line section-realizations__btn"
											>
												{t("Więcej")}
											</Link>
										</div>
									</div>
								</div>
							);
						})}
					</Slider>
				</div>
			</section>

			<section className="section-news">
				<div className="container">
					<h2 className="section-news__title">{home.newstitle}</h2>

					<Slider {...newsSliderOptions}>
						{postsFilteredByLang.map((item) => (
							<div>
								<NewsTile
									key={item?.id}
									link={item.uri}
									date={item.date}
									image={item.featuredImage?.node.sourceUrl}
									title={item.title}
									desc={item.postAcf.shortDesc}
								/>
							</div>
						))}
					</Slider>

					<Link
						to={t("/aktualnosci/")}
						className="link-line section-news__btn"
					>
						{t("Wszystkie")}
					</Link>
				</div>
			</section>

			{home.clientsslideshow !== null && (
				<section className="section-clients">
					<div className="container">
						<h2 className="section-clients__title">
							{home.clientstitle}
						</h2>
						<Slider {...clientsSliderOptions}>
							{home.clientsslideshow.map((item, index) => {
								return (
									<div
										className="section-clients__img-wrapper"
										key={index}
									>
										<img
											src={item.sourceUrl}
											alt=""
											className="img-fluid section-clients__img"
										/>
									</div>
								);
							})}
						</Slider>
					</div>
				</section>
			)}

			<Newsletter
				lang={lang}
				title={home?.newsletterTitle}
				text={home?.newsletterText}
			/>
		</Layout>
	);
};

export const query = graphql`
	query {
		allWpPost(sort: { fields: date, order: DESC }) {
			nodes {
				id
				featuredImage {
					node {
						sourceUrl
					}
				}
				language {
					slug
				}
				date(formatString: "DD-MM-yyyy")
				postAcf {
					shortDesc
				}
				uri
				title
			}
		}
	}
`;

export default Home;
